import { crownApi } from '@/common/api/crownQueryClient';
import { Components } from '@/openapi';

export const startApplication = async (
  params: Components.Schemas.StartApplicationParamsDto,
) => {
  return (await crownApi.UserApplications_startApplication(null, params)).data!;
};
export const startApplicationMutation = {
  mutationFn: startApplication,
};
